export enum BadgeVariant {
  BUMP_OUT_HEATHER = 'bump-out-heather',
  BUMP_OUT_NORDIC_BLUE = 'bump-out-nordic-blue',
  ROUNDED_TOP_RIGHT = 'rounded-top-right',
  ROUNDED_TOP_LEFT = 'rounded-top-left',
}
